module.exports = __webpack_public_path__ + "static/media/navidad13.ffa87857.webp";